/* istanbul ignore file */

import { Breakpoint } from './constants';
import { generateMediaQuery, QueryOptions } from './generateMediaQuery';

export const media = {
  phone: (options?: QueryOptions) => generateMediaQuery(Breakpoint.PHONE, options),
  tablet: (options?: QueryOptions) => generateMediaQuery(Breakpoint.TABLET, options),
  desktop: (options?: QueryOptions) => generateMediaQuery(Breakpoint.DESKTOP, options),
  wide: (options?: QueryOptions) => generateMediaQuery(Breakpoint.WIDE, options),
};
